import core from './api/core'
import cdp from './api/cdp'
import content from './api/content'
import fileservice from './api/fileservice'
import job from './api/job'
import node from './api/node'
import ai_workforce from './api/ai_workforce'
import business from './api/business'

export default {
  core,
  cdp,
  content,
  fileservice,
  node,
  job,
  ai_workforce,
  business
}
